import React, { Component } from "react";
import { Link } from "react-router-dom";
import LogoSlider from "../../components/LogoSlider/LogoSlider";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import './Home.css'
export default class Home extends Component {
  render() {
    return (
      <div>
        <div className="hero-banner position-relative">
          <img
            src="./assets/images/ambrum-home-hero.png"
            alt=""
            className="hero-image"
          />
          <div className="position-absolute bottom-0 hero-text-2 start-0 px-5 py-3">
            <p>
              <span className="hero-text-color-1">Complexity</span> made Simple{" "}
              <br />
              with <span className="hero-text-color-1">Powerful Solutions</span>
            </p>
          </div>
        </div>


        <div className="my-2">
          <LogoSlider />
        </div>
        <div className="text-center mt-5">
          <p className="hero-text">
            INNOVATING TECHNOLOGY <br /> EMPOWERING BRANDS
          </p>
          <p className=" text-center">
            Ambrum is the parent company based in Sri Lanka with roots overseas.{" "}
            <br />
            The versatility of our product offering has evolved exponentially
            over the years as we are now capable of <br />
            delivering dynamic products to a multitude of <br />
            companies locally and globally.
          </p>
          <Link to="/talk-to-us">
            <button className="primary-btn fw-500">
              Book a free consultation
            </button>
          </Link>
          <p className="hero-text mt-5 mb-4">WHAT WE DO</p>
        </div>

        <div className="row container m-auto border-top mt-4 p-5">
          <Link to="/services/software-mobile" style={{ textDecoration: 'none', color: 'inherit' }} className="col-6 border-end">
            <div className="home-card p-4">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/menu.gif" className="w-50" alt="Software Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">
                    Custom Software & Mobile App Development
                  </h5>
                  <p>
                    Scalable web & mobile solutions tailored to business needs
                  </p>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/services/sub-services?service=brand-strategy" style={{ textDecoration: 'none', color: 'inherit' }} className="col-6">
            <div className="home-card p-4">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/flow-chart-1.gif" className="w-50" alt="Brand Strategy Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">Brand Strategy & Identity Development</h5>
                  <p>Positioning, branding, and creative identity design</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="row container m-auto border-top p-5">
          <Link to="/services/sub-services?service=smart-city" style={{ textDecoration: 'none', color: 'inherit' }} className="d-flex">
            <div className="home-card p-4 w-100">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/map.gif" className="w-25" alt="Smart City Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">Smart City & Infrastructure Solutions</h5>
                  <p>Digital ecosystems for smart city management...</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="row container m-auto border-top mt-4 p-5">
          <Link to="/services/sub-services?service=digital-marketing" style={{ textDecoration: 'none', color: 'inherit' }} className="col-6 border-end">
            <div className="home-card p-4">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/encryption.gif" className="w-50" alt="Digital Marketing Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">Performance-Driven Digital Marketing</h5>
                  <p>ROI-focused campaigns. Data-driven SEO & paid advertising strategies</p>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/services/sub-services?service=e-ticketing" style={{ textDecoration: 'none', color: 'inherit' }} className="col-6">
            <div className="home-card p-4">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/tickets.gif" className="w-50" alt="E-Ticketing Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">E-Ticketing & Event Management Solutions</h5>
                  <p>Seamless ticketing, booking, and event coordination systems</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="row container m-auto border-top p-5">
          <Link to="/services/sub-services?service=ev-charging" style={{ textDecoration: 'none', color: 'inherit' }} className="d-flex w-100">
            <div className="home-card p-4 w-100">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/charging-station.gif" className="w-25" alt="EV Charging Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">EV Charging & Sustainable Tech Solutions</h5>
                  <p>
                    Advanced EV charging software & network management. Smart energy & mobility integration for businesses
                  </p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="row container m-auto border-top p-5">
          <Link to="/services/sub-services?service=healthcare" style={{ textDecoration: 'none', color: 'inherit' }} className="d-flex w-100">
            <div className="home-card p-4 w-100">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/doctors-office.gif" className="w-25" alt="Healthcare Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">Healthcare & E-Channeling Solutions</h5>
                  <p>
                    Digital platforms for patient booking & medical record tracking.
                    Telemedicine & AI-powered health tech solutions
                  </p>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="row container m-auto border-top mt-4 p-5">
          <Link to="/services/sub-services?service=social-media" style={{ textDecoration: 'none', color: 'inherit' }} className="col-6 border-end">
            <div className="home-card p-4">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/content-media.gif" className="w-50" alt="Content Media Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">Content & Social Media Growth</h5>
                  <p>
                    High-impact content creation & community engagement.
                    Video production and storytelling
                  </p>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/services/sub-services?service=e-commerce" style={{ textDecoration: 'none', color: 'inherit' }} className="col-6">
            <div className="home-card p-4">
              <div className="row">
                <div className="col-4 m-auto text-end">
                  <img src="./assets/icons/online-shopping.gif" className="w-50" alt="E-Commerce Icon" />
                </div>
                <div className="col-8">
                  <h5 className="fw-600">E-Commerce & Conversion Optimization</h5>
                  <p>
                    Sales funnel development, retention marketing, and automation.
                  </p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <ContactUsFooter />
        <br />
        <Footer />
      </div>
    );
  }
}
